import { ChevronDown } from "lucide-react";
import { useEffect, useState } from "react";

// Scroll Indicator Component
const ScrollIndicator = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [isAtBottom, setIsAtBottom] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      const atBottom = scrollTop + windowHeight >= documentHeight - 100;
      setIsAtBottom(atBottom);
      setIsVisible(!atBottom && documentHeight > windowHeight);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, []);

  const scrollDown = () => {
    const currentScroll = window.pageYOffset;
    const targetScroll = currentScroll + window.innerHeight * 0.8;

    window.scrollTo({
      top: targetScroll,
      behavior: "smooth",
    });
  };

  if (!isVisible) return null;

  return (
    <>
      <div className="position-fixed pb-4" style={{zIndex: 1000, bottom: "100px", right: "60px"}}>
        <button
          onClick={scrollDown}
          className={`btn rounded-circle p-3 border-0 shadow-lg scroll-indicator ${
            isAtBottom ? "at-bottom" : ""
          }`}
          style={{
            backgroundColor: isAtBottom ? "#6c757d" : "#8077ec",
            color: "white",
            width: "56px",
            height: "56px",
            transition: "all 0.3s ease",
            animation: isAtBottom ? "none" : "bounceUpDown 2s infinite",
            opacity: isAtBottom ? 0.5 : 1,
            cursor: isAtBottom ? "not-allowed" : "pointer",
          }}
          disabled={isAtBottom}
          aria-label="Scroll down to see more content"
        >
          <ChevronDown
            size={24}
            style={{
              transition: "transform 0.3s ease",
              transform: isAtBottom ? "scale(0.8)" : "scale(1)",
            }}
          />
        </button>
      </div>

      <style>{`
        @keyframes bounceUpDown {
          0%, 20%, 50%, 80%, 100% {
            transform: translateY(0);
          }
          40% {
            transform: translateY(-8px);
          }
          60% {
            transform: translateY(-4px);
          }
        }
        
        .scroll-indicator:hover:not(:disabled) {
          transform: scale(1.1) !important;
          box-shadow: 0 8px 25px rgba(0, 123, 255, 0.3) !important;
        }
        
        .scroll-indicator.at-bottom:hover {
          transform: none !important;
          box-shadow: 0 4px 15px rgba(108, 117, 125, 0.2) !important;
        }
        
        .scroll-indicator:focus {
          outline: none !important;
          box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25) !important;
        }
      `}</style>
    </>
  );
};

export default ScrollIndicator;
